var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.041 14.791H4.583v1.459H6.04V14.79zM6.041 11.875H4.583v1.458H6.04v-1.458zM6.041 8.957H4.583v1.459H6.04V8.957zM12.604 14.791h-2.188v1.459h2.188V14.79zM16.25 14.791h-2.187v1.459h2.187V14.79zM12.604 11.875h-2.188v1.458h2.188v-1.458zM16.25 11.875h-2.187v1.458h2.187v-1.458zM12.604 8.957h-2.188v1.459h2.188V8.957zM16.25 8.957h-2.187v1.459h2.187V8.957zM16.25 6.042h-2.187V7.5h2.187V6.042zM12.604 6.042h-2.188V7.5h2.188V6.042z",
    fill: "#85A5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.667v3.919L1.665 6.68v12.486h17.5V3.854L7.499 1.666zm0 16.041H3.123V7.89L7.5 7.07v10.638zm10.208 0h-8.75V3.424l8.75 1.64v12.644z",
    fill: "#85A5FF"
  })));
}

export default __webpack_public_path__ + "./fonts/business.da652e148a6457e63a184fbd13ad6ddc.svg";
export { SvgBusiness as ReactComponent };